export default "__VITE_ASSET__Zk8lFniq__"